module.exports = __webpack_public_path__ + "static/media/arrow-right.f615455c.svg";